import { GRAND_ALL, GRAND_CARD, GRAND_PRIZE_COUNT } from '../campaign';
import { PrizeArt, Rays, SectionTitle } from './Shared';
import { ChevronSmIcon } from './Icons';

const DEFAULT_PRIZES = { total: GRAND_PRIZE_COUNT, all: GRAND_ALL };

/* Picks the card's prizes out of the API list by name (campaign.js
   GRAND_CARD), topping up from the rest of the list so a renamed prize
   never leaves a hole. */
function layout(all) {
  const byName = new Map(all.map((g) => [g.name, g]));
  const used = new Set();
  const take = (name) => {
    let g = byName.get(name);
    if (!g || used.has(g)) g = all.find((x) => !used.has(x));
    if (g) used.add(g);
    return g || null;
  };
  const hero = take(GRAND_CARD.hero);
  const pair = GRAND_CARD.pair.map(take).filter(Boolean);
  const minis = GRAND_CARD.minis
    .map((m) => { const g = take(m.name); return g && { prize: g, label: g.name === m.name ? m.label : g.name }; })
    .filter(Boolean);
  return { hero, pair, minis };
}

/* Dark band with the grand prizes card — the iPhone up top, a pair of tiles,
   four minis — and a link to the full list. `prizes` is the API's
   { total, all: [{ art, name, sub, ... }] }. */
export default function GrandPrizes({ prizes = DEFAULT_PRIZES, onViewAll }) {
  const { hero, pair, minis } = layout(prizes.all && prizes.all.length ? prizes.all : GRAND_ALL);
  return (
    <div className="gq-band">
      <Rays />
      <SectionTitle variant="grand">Golden Chest Prizes</SectionTitle>
      <div className="gq-gsub">Stand a chance to win from a pool of mega prizes</div>
      <div className="gq-gcard">
        {hero && (
          <div className="gq-ghero">
            <PrizeArt prize={hero} className="gq-gim" />
            <div className="gq-gnm">{hero.name}</div>
            <div className="gq-gsb">{hero.sub} · Grand prize</div>
          </div>
        )}
        <div className="gq-gpair">
          {pair.map((p) => (
            <div className="gq-gtile" key={p.name}>
              <PrizeArt prize={p} className="gq-gim" />
              <div className="gq-gnm">{p.name}</div>
              <div className="gq-gsb">{p.sub}</div>
            </div>
          ))}
        </div>
        <div className="gq-gminis">
          {minis.map(({ prize, label }) => (
            <div className="gq-gmini" key={prize.name}>
              <PrizeArt prize={prize} className="gq-mim" />
              <span>{label}</span>
            </div>
          ))}
        </div>
        <button type="button" className="gq-more" onClick={onViewAll}>
          View all {prizes.total} grand prizes<ChevronSmIcon />
        </button>
      </div>
    </div>
  );
}
